import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import MainLayout from "@/layouts/MainLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ForSchools from "@/pages/ForSchools";
import ForParents from "@/pages/ForParents";
import DentalVan from "@/pages/DentalVan";
import FAQs from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";
import Accessibility from "@/pages/Accessibility";
import Cookies from "@/pages/Cookies";
import ParentConsent from "@/pages/ParentConsent";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/AdminLogin";
import AdminEnquiries from "@/pages/AdminEnquiries";
import AdminForgotPassword from "@/pages/AdminForgotPassword";
import AdminResetPassword from "@/pages/AdminResetPassword";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            {/* Admin routes — no site header/footer/floating contact */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route
              path="/admin/enquiries"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminEnquiries />
                </ProtectedRoute>
              }
            />

            {/* Public site routes with header/footer */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/for-schools" element={<ForSchools />} />
              <Route path="/for-parents" element={<ForParents />} />
              <Route path="/dental-van" element={<DentalVan />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="/cookies-policy" element={<Cookies />} />
              <Route path="/parent-consent" element={<ParentConsent />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
